import { ChangeDetectorRef, Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppObservable } from './utils/services/app-observable';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  public showSpinner = true;

  constructor(
    private translate: TranslateService,
    private appObservable: AppObservable,
    private router: Router,
    private cdref: ChangeDetectorRef
  ) {
    let lang = 'es';
    let getLang = localStorage.getItem('i18n');
    if (getLang != null) { lang = getLang; }
    this.translate.setDefaultLang(lang);
    this.appObservable.language.next(lang);

    let getActiveDavosHelp = localStorage.getItem('activeDavosHelp');
    if (getActiveDavosHelp == 'true') {
      this.appObservable.davosHelp.next(true);
    }

    this.appObservable.language.subscribe((lang) => {
      localStorage.setItem('i18n', lang);
      this.translate.setDefaultLang(lang)
    });

    this.appObservable.davosHelp.subscribe(active => {
      localStorage.setItem('activeDavosHelp', active.toString());
    });

    this.appObservable.loadingSpinner.subscribe(load => {
      // console.log('load', load)
      // if (load == false) {
      //   setTimeout(() => {
      //     this.showSpinner = load;
      //   }, 500);
      //   return
      // }

      // console.log(load)
      // this.showSpinner = load;
      setTimeout(() => {
        if (load) {
          document.getElementById('loading-spinner').style.display = 'block';
        } else {
          document.getElementById('loading-spinner').style.display = 'none';
        }
      }, 0);
    });

    this.router.events.subscribe((event) => {
      let modalActiveList = this.appObservable.modalActiveList.getValue();
      modalActiveList.forEach((modal) => { modal.close(); });
      this.appObservable.modalActiveList.next([]);

      if (event instanceof NavigationStart) {
        // this.appObservable.loadingSpinner.next(true)
      } else if (event instanceof NavigationEnd) {
        const currentUrl = event.url;
        if (currentUrl != '/home/container') {
          window.scrollTo(0, 0);
        }
        setTimeout(() => {
          // this.appObservable.loadingSpinner.next(false);
        }, 0);
      }
    });

    let isActiveTab = true;
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === 'visible') {
        isActiveTab = true;
      } else {
        isActiveTab = false;
      }
    });

    window.addEventListener('storage', (event) => {
      if (event.key === 'acct' || event.key === 'ucx' || event.key === 'upx' || event.key === 'ux') {
        if (!isActiveTab) {
          if (event.key === 'ucx' && this.router.url === '/home/company/grid') {
            this.router.navigate(['home/container']).then(() => {
              location.reload();
            });
          } else {
            location.reload();
          }
        }
      }
    });

  }

  ngAfterContentChecked() {
    // this.cdref.detectChanges();
  }

}
